import React, { memo, useState } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Button from '@material-ui/core/Button';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import messages from 'aurora-translations';
import ADGMResponsiveModal from '../../../ADGMResponsiveModal';
import FilterList from './FilterList';
import FilterListDetails from './FilterListDetails';
import styles from './styles';

function MobileFilters(props) {
  const {
    classes,
    isModalOpen,
    formData,
    toggleModal,
    handleSelectChange,
    handleResetForm,
    handleSearch,
    getDropdownData,
    dropdownData,
    ...otherProps
  } = props;
  const [activeModal, setActiveModal] = useState(null);

  const onSearchClick = () => {
    toggleModal();
    handleSearch();
  };

  const onResetClick = () => {
    toggleModal();
    handleResetForm();
  };

  return (
    <ADGMResponsiveModal
      open={isModalOpen}
      toggleModal={toggleModal}
      disableScrollLock={false}
      {...{ title: <FormattedMessage {...messages.search_for_non_UAE_resident_buyer} /> }}
      rightAction={
        <Button color='primary' onClick={onResetClick} className={classes.resetButton}>
          <FormattedMessage {...messages.Clear} />
        </Button>
      }
      customClasses={{ content: classes.filterModal }}
    >
      <FilterList
        setActiveModal={setActiveModal}
        formData={formData}
        getDropdownData={getDropdownData}
        handleSelectChange={handleSelectChange}
        dropdownData={dropdownData}
        {...otherProps}
      />
      {activeModal && (
        <FilterListDetails
          activeModal={activeModal}
          setActiveModal={setActiveModal}
          formData={formData}
          getDropdownData={getDropdownData}
          handleSelectChange={handleSelectChange}
          dropdownData={dropdownData}
        />
      )}
      <div className={classes.searchButtonHolder}>
        <Button
          variant='contained'
          color='primary'
          type='submit'
          onClick={onSearchClick}
          className={classNames(classes.redButton, classes.searchButton)}
        >
          <FormattedMessage {...messages.search} />
        </Button>
      </div>
    </ADGMResponsiveModal>
  );
}

MobileFilters.propTypes = {
  classes: PropTypes.object.isRequired,
  formData: PropTypes.object.isRequired,
  districtData: PropTypes.object.isRequired,
  toggleModal: PropTypes.func.isRequired,
  isModalOpen: PropTypes.bool.isRequired,
  handleSelectChange: PropTypes.func.isRequired,
  handleResetForm: PropTypes.func.isRequired,
  handleSearch: PropTypes.func.isRequired,
  getDropdownData: PropTypes.func.isRequired,
  offPlanUnitUsageList: PropTypes.array.isRequired,
  dropdownData: PropTypes.array.isRequired,
};

export default withStyles(styles)(memo(MobileFilters));
